export class CorpTaxDatesDto {
    showExistingPrior: boolean = false;
    priorFROM = "";
    priorTO = "";
    priorPaidIn = "";

    showExisting: boolean = false;
    FROM = "";
    TO = "";
    existingPaidIn = "";

    taxOwedText = "";
    existingTaxPrior = 0;

}